import React, { FC, useEffect, useState } from 'react';
import { TablesNames } from '../../../../store/tables/tables-context';
import { Table } from '../../../table/Table';
import { MRT_RowSelectionState } from 'material-react-table';
import { DisputesQueueDetailsHeader } from './DisputesQueueDetailsHeader';
import { ITransactionsData, ITransactionsPaginationData } from '../../../../store/payments/payments-interfaces-helper';
import { fetchTransactionsData, } from '../../../../store/payments/actions/transactions';
import { useLocation } from 'react-router-dom';
import { useDisputesContext } from '../../../../store/disputes/disputes-context';
import { ITransactionsFilters } from '../../../transactions/TransactionsPageFilter';

interface Props {
	checkedItem: ITransactionsData | null;
	setCheckedItem?: (value: ITransactionsData) => void;
	rowSelection?: MRT_RowSelectionState;
	setRowSelection?: (value: MRT_RowSelectionState) => void
}

export const DisputesQueueDetailsList: FC<Props> = (props) => {
	const { rowSelection, setRowSelection, checkedItem, setCheckedItem } = props;
	const { state } = useLocation();

	const { disputesContextState: { disputeDetails }} = useDisputesContext();

	// const initialProviderName = disputeDetails?.providerName === 'Paysafe'
	// 	? [disputeDetails?.providerName.toLowerCase()]
	// 	: [];

	const getOrderId = (): string => {
		if (disputeDetails?.providerName === 'Paysafe' && disputeDetails?.authorizationId) {
			return disputeDetails?.authorizationId.slice(0, 36);
		} else {
			disputeDetails?.orderId;
		}
	};

	const [from, setFrom] = useState<Date | string>(null);
	const [to, setTo] = useState<Date | string>(null);
	// const [provider, setProvider] = useState<string[]>(initialProviderName);
	const [type, setType] = useState<string[]>(['Capture', 'Debit']);
	const [status, setStatus] = useState<string[]>([]);
	const [arn, setArn] = useState<string>('');
	const [amount, setAmount] = useState<string>(String(disputeDetails?.amount));
	const [bin, setBin] = useState<string>(disputeDetails?.bin);
	const [last4, setLast4] = useState<string>(disputeDetails?.last4);
	const [orderId, setOrderId] = useState<string>(getOrderId());
	const [transactionId, setTransactionId] = useState<string>('');
	const [externalReferenceId, setExternalReferenceId] = useState<string>('');
	const [authCode, setAuthCode] = useState<string>('');
	const [query, setQuery] = useState<string>('');
	const [pageSize, setPageSize] = useState<string>('10');
	const [pageNumber, setPageNumber] = useState<string>('1');
	const [appliedFiltersState, setAppliedFiltersState] = useState<ITransactionsFilters>(null);

	const [transactionsListData, setTransactionsListData] = useState<ITransactionsPaginationData>(null);
	const [isTransactionsListLoading, setIsTransactionsListLoading] = useState<boolean>(false);

	const fetchPotentialMatchedTransactions = async (): Promise<void> => {
		setIsTransactionsListLoading(true);

		const params = {
			pageSize: pageSize,
			pageNumber: pageNumber,
			id: state?.disputeQueueItem?.potentialMatchesTransactionIds
		};
		const data = await fetchTransactionsData(params);

		setTransactionsListData(data);

		setIsTransactionsListLoading(false);
	};


	useEffect(() => {
		if (state?.disputeQueueItem?.potentialMatchesTransactionIds?.length) {
			void fetchPotentialMatchedTransactions();
		}
	}, []);

	const listener = async (searchParams: ITransactionsFilters): Promise<void> => {

		if (Object.keys(searchParams).length) {
			setIsTransactionsListLoading(true);

			setFrom(searchParams?.from ?? null);
			setTo(searchParams?.to ?? null);
			setArn(searchParams?.arn ?? '');
			setAmount(searchParams?.amount ?? '');
			setBin(searchParams?.bin ?? '');
			setLast4(searchParams?.last4 ?? '');
			setOrderId(searchParams?.orderId ?? '');
			setTransactionId(searchParams?.transactionId ?? '');
			setExternalReferenceId(searchParams?.externalReferenceId ?? '');
			setAuthCode(searchParams?.authCode ?? '');
			setQuery(searchParams?.query ?? '');
			setPageSize(searchParams?.pageSize ?? '10');
			setPageNumber(searchParams?.pageNumber ?? '1');

			// if (searchParams?.provider && typeof searchParams?.provider === 'string') {
			// 	setProvider([searchParams.provider]);
			// } else {
			// 	setProvider(searchParams?.provider ?? []);
			// }

			if (searchParams?.type && typeof searchParams?.type === 'string') {
				setType([searchParams.type]);
			} else {
				setType(searchParams?.type ?? []);
			}

			if (searchParams?.status && typeof searchParams?.status === 'string') {
				setStatus([searchParams.status]);
			} else {
				setStatus(searchParams?.status ?? []);
			}

			const initialFilters = {
				from: searchParams?.from ?? null,
				to: searchParams?.to ?? null,
				arn: searchParams?.arn ?? '',
				amount: searchParams?.amount ?? '',
				bin: searchParams?.bin ?? '',
				last4: searchParams?.last4 ?? '',
				orderId: searchParams?.orderId ?? '',
				transactionId: searchParams?.transactionId ?? '',
				externalReferenceId: searchParams?.externalReferenceId ?? '',
				authCode: searchParams?.authCode ?? '',
				query: searchParams?.query ?? '',
				pageSize: searchParams?.pageSize ?? '10',
				pageNumber: searchParams?.pageNumber ?? '1',
				provider: searchParams?.provider && typeof searchParams?.provider === 'string'
					? [searchParams.provider]
					: searchParams?.provider ?? [],
				type: searchParams?.type && typeof searchParams?.type === 'string'
					? [searchParams.type]
					: searchParams?.type ?? [],
				status: searchParams?.status && typeof searchParams?.status === 'string'
					? [searchParams.status]
					: searchParams?.status ?? [],
			};

			setAppliedFiltersState(initialFilters);

			const data = await fetchTransactionsData(searchParams);

			setTransactionsListData(data);

			setIsTransactionsListLoading(false);
		}
	};

	return (
		<div>
			<DisputesQueueDetailsHeader
				checkedItem={checkedItem}
				setCheckedItem={setCheckedItem}
				rowSelection={rowSelection}
				from={from}
				setFrom={setFrom}
				to={to}
				setTo={setTo}
				// provider={provider}
				// setProvider={setProvider}
				type={type}
				setType={setType}
				status={status}
				setStatus={setStatus}
				arn={arn}
				setArn={setArn}
				amount={amount}
				setAmount={setAmount}
				bin={bin}
				setBin={setBin}
				last4={last4}
				setLast4={setLast4}
				orderId={orderId}
				setOrderId={setOrderId}
				transactionId={transactionId}
				setTransactionId={setTransactionId}
				externalReferenceId={externalReferenceId}
				setExternalReferenceId={setExternalReferenceId}
				authCode={authCode}
				setAuthCode={setAuthCode}
				query={query}
				setQuery={setQuery}
				pageSize={pageSize}
				pageNumber={pageNumber}
				appliedFiltersState={appliedFiltersState}
				setAppliedFiltersState={setAppliedFiltersState}
				transactionsData={transactionsListData?.rows}
				isTranslationDataLoading={isTransactionsListLoading}
			/>

			<div className="card">
				<div className="card-body pt-0">
					<Table
						name={TablesNames.disputesTransactionTableData}
						data={transactionsListData?.rows ?? []}
						isLoading={isTransactionsListLoading}
						totalItemCount={transactionsListData?.totalItemCount}
						rowSelection={rowSelection}
						setRowSelection={setRowSelection}
						enableRowSelection={true}
						enableSelectAll={false}
						queryParamsListener={listener}
						enableRowClicking={true}
						enableMultiRowSelection={false}
						toolbarCustomAction={<div className="fs-2">Possible transaction matches</div>}
					/>
				</div>
			</div>
		</div>
	);
};
